module.exports = __webpack_public_path__ + "static/img/img-base-price.6b33b584.png";